import type { OAIError } from '~/types/openapi';

export class OAIApiError extends Error {
  public readonly statusCode: number;

  public readonly code: string;

  public readonly userMessage?: string;

  public readonly message: string;

  public readonly details: { [key: string]: unknown } | undefined;

  public readonly traceId: string;

  public readonly url: string;

  constructor(statusCode: number, response: OAIError, url: string) {
    super(response.message);

    this.statusCode = statusCode;
    this.code = response.code;
    this.message = response?.message || '';
    this.userMessage = response.userMessage;
    this.details = response.details as { [key: string]: unknown } | undefined;
    this.traceId = response.traceId;
    this.url = url; // API
  }
}
